<i class="bi bi-bootstrap-reboot"></i>
    Session Timeout Warning
  
  <mat-dialog-content>
    <p>Your session is about to expire due to inactivity.</p>
    <p>You will be logged out in <strong class="countdown" [ngClass]="{'red-text' : countdown < 30}">{{ countdown }} seconds</strong>.</p>
  </mat-dialog-content>
  
  <mat-dialog-actions>
    <button mat-button (click)="extendSession()">Stay Logged In</button>
    <button mat-button color="warn" (click)="logoutNow()">Logout</button>
  </mat-dialog-actions>
  